<template>
  <div>
    <div class="card">
      <div class="card-content">

        <h4 class="card-title">Histórico de Declaraciones</h4>
        <v-dialog v-model="intDialogVisible" transition="dialog-bottom-transition">
          <template v-slot:default="dialog">
            <v-card>
              <v-card-title>{{modalTitle}}</v-card-title>
              <v-card-text class="border-top" v-if="loadBitacora">
                <v-card-subtitle>Espere por favor...</v-card-subtitle>
                <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
              </v-card-text>
              <v-card-text class="border-top" v-else>
                <v-row class="pt-3">
                  <v-col cols="12">
                    <div>
                      <label class="font-weight-bold">Dependencia Origen</label>
                      <div> <strong> {{correccion.dependencia_orgen}}</strong></div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <div>
                      <label class="font-weight-bold">Dependencia Destino</label><br>
                      <el-select clearable class="select-default" filterable name="dependencia_cambio" v-validate="'required'" placeholder="Dependencia" v-model="correccion.dependencia_destino_id">
                        <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
                        </el-option>
                      </el-select>
                      <small class="text-danger">
                        {{ getError('dependencia_cambio') }}
                      </small>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div>
                      <label class="font-weight-bold">
                        Tipo declaración
                      </label>
                      <el-select class="select-default" filterable name="tipo_dec" placeholder="Tipo declaración" v-validate="'required'" v-model="correccion.tipo_declaracion_id">
                        <el-option v-for="option in tipo_declaracion" class="select-default" :value="option.id" :label="option.valor" :key="option.id+'tipo'">
                        </el-option>
                      </el-select>
                      <small class="text-danger">
                        {{ getError('tipo_dec') }}
                      </small>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div>
                      <label class="font-weight-bold">
                        Periodo
                      </label>
                      <el-select class="select-default" filterable name="periodo" placeholder="Periodo" v-validate="'required'" v-model="correccion.periodo">
                        <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
                        </el-option>
                      </el-select>
                      <small class="text-danger">
                        {{ getError('periodo') }}
                      </small>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div>
                      <label class="control-label">Observaciones</label>
                      <textarea class="form-control" type="text" name="observaciones" v-model="correccion.observaciones" v-validate="'required'" placeholder="Motivos/Observaciones"></textarea>
                      <small class="text-danger">
                        {{ getError('observaciones') }}
                      </small>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text class="border-top" v-if="!loadBitacora">
                <v-row class="pt-3">
                  <v-col cols="12" class="text-center">
                    <v-btn color="success" :loading="loadCorreccion" :disabled="loadCorreccion" outlined @click="makeCorrection"><i class="fas fa-save mr-3"></i> Generar Correción</v-btn>
                  </v-col>

                </v-row>

              </v-card-text>
              <!-- <v-card-text class="border-top" v-if="!loadBitacora">
                <v-row class="pt-3">
                  <v-col cols="6">
                    <strong>
                      Origen
                    </strong>
                    <div class="p-3">
                      <div v-for="(item, index) in correccion.origen" :key="index">
                        <v-card class="mx-auto p-1 pr-3 pl-3 mb-2" outlined>
                          <div class="text-overline mb-0">
                            {{index}}
                          </div>
                          <div class="card-sub">{{item}}</div>
                        </v-card>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <strong>
                      Destino
                    </strong>
                    <div>

                    </div>
                  </v-col>
                </v-row>

              </v-card-text> -->
              <v-card-actions class="justify-end border-top">
                <v-btn text @click="dialog.value = false">Cerrar</v-btn>
                <!-- <v-btn  color="error"  text @click="dialog.value = false">Guardar</v-btn> -->
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <div class="row" v-show="shlista">
          <div v-if="rol===4 || rol===5 || rol ===14">
          </div>
          <div v-else class="col-md-8">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6" v-if="filtrainici">
            <label>Filtra por inicial de RFC</label>
            <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="iniciales" @change="traeiniciales">
              <el-option v-for="option in inicialeslst" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>
          <div v-if="rol!=4" class="col-md-4 pull-left">
            <button @click="getDeclaraciones" class="btn btn-fill btn-success" :disabled="loading">
              {{loading ? 'Buscando...': 'Buscar'}}
            </button>
          </div>
        </div>
        <br>
        <div v-show="shlista">
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table :headers="headers" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">
                    <b-button @click.prevent="historico(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Ver histórico'">
                      <i class="fas fa-history"></i></b-button>
                  </div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div>{{dateFormat(item.fecha)}}</div>
                </template>
              </v-data-table>

              <v-data-table v-show="shhistorico" :headers="headers2" :items="table_list" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">
                    <b-button @click.prevent="editBitacora(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Agregar Correción'">
                      <i class="fas fa-pencil-alt"></i>
                    </b-button>
                  </div>
                </template>
                <template v-slot:item.periodo="{ item }">
                  <!-- <div>{{filterAnio(item.created_at)}}</div> -->
                  <div>{{item.periodo}}</div>
                </template>

                <template v-slot:item.patrimonial="{ item }">
                  <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargar(item.id)">
                    <i class="far fa-file-pdf"></i>
                  </b-button>
                </template>

              </v-data-table>
            </div>
          </div>
        </div>


      </div>


      <div class="card-content" v-show="shhistorico">
        <button @click="regresar" class="btn btn-fill btn-success pull-right">
          Regresar
        </button>
        <br><br><br>
        <div>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-chip class="ma-2" color="primary" label>
              <v-icon left>fas fa-user</v-icon>
              {{nombre}}
            </v-chip>
            <v-chip class="ma-2" color="primary" label>
              <v-icon left>fas fa-calendar</v-icon>
              Fecha de Alta: {{alta}}
            </v-chip>
            <v-chip class="ma-2" color="red" label v-if="baja">
              <v-icon left>fas fa-calendar</v-icon>
              Baja: {{baja}}
            </v-chip>
            <v-chip class="ma-2" color="success" label v-else>
              <v-icon left>fas fa-calendar</v-icon>
              ACTIVO
            </v-chip>

            <v-data-table v-if="rol!=4" :headers="headers2" :items="table_list" :items-per-page="5" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editBitacora(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Agregar Correción'">
                    <i class="fas fa-pencil-alt"></i>
                  </b-button>
                </div>
              </template>
              <template v-slot:item.periodo="{ item }">
                <!-- <div>{{filterAnio(item.created_at)}}</div> -->
                <div>{{item.periodo}}</div>
              </template>

              <template v-slot:item.patrimonial="{ item }">
                <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargar(item)">
                  <i class="far fa-file-pdf"></i>
                </b-button>
              </template>

              <template v-slot:item.fiscal="{ item }">
                <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaFiscal(item.declaracion_fiscal)">
                  <i class="far fa-file-pdf"></i>
                </b-button>
              </template>

              <template v-slot:item.acuse="{ item }">
                <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaAcuse(item)">
                  <i class="far fa-file-pdf"></i>
                </b-button>
              </template>

              <template v-slot:item.aclaraciones="{ item }">
                <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaAclaracion(item.aclaraciones)">
                  <i class="fas fa-info"></i>
                </b-button>
              </template>

              <template v-slot:item.entidad="{ item }">
                <div class="text-left">{{getEntidad(item)}}</div>
              </template>

              <template v-slot:item.posesion="{ item }">
                <div class="text-left">{{getFechaPos(item)}}</div>
              </template>

              <template v-slot:item.presentacion="{ item }">
                <div class="text-left">{{ dateFormat(item.created_at) }}</div>
              </template>

              <template v-slot:item.cargo="{ item }">
                <div class="text-left">{{getCargo(item)}}</div>
              </template>
            </v-data-table>
            <v-data-table v-else :headers="headers3" :items="table_list" :items-per-page="5" class="" :fixed-header="true">

              <template v-slot:item.periodo="{ item }">
                <!-- <div>{{filterAnio(item.created_at)}}</div> -->
                <div>{{item.periodo}}</div>
              </template>

              <template v-slot:item.acuse="{ item }">
                <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaAcuse(item)">
                  <i class="far fa-file-pdf"></i>
                </b-button>
              </template>

              <template v-slot:item.entidad="{ item }">
                <div class="text-left">{{getEntidad(item)}}</div>
              </template>

              <template v-slot:item.posesion="{ item }">
                <div class="text-left">{{getFechaPos(item)}}</div>
              </template>

              <template v-slot:item.presentacion="{ item }">
                <div class="text-left">{{ dateFormat(item.created_at) }}</div>
              </template>

              <template v-slot:item.cargo="{ item }">
                <div class="text-left">{{getCargo(item)}}</div>
              </template>
            </v-data-table>
            <v-chip v-if="justificados.length > 0" class="ma-2" color="primary" label>
              <v-icon left>fas fa-user</v-icon>
              {{"DECLARACIONES JUSTIFICADAS"}}
            </v-chip>
            <v-data-table v-if="justificados.length > 0" :headers="headers4" :items="justificados" :items-per-page="5" class="" :fixed-header="true">
            </v-data-table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data() {
      return {
        loadBitacora: true,
        loadCorreccion: false,
        correccion: {
          id: null,
          ip_id: null,
          declaracion_id: null,
          dependencia_orgen: null,
          dependencia_orgen_id: null,
          dependencia_destino_id: null,
          periodo: null,
          tipo_declaracion_id: null,
          observaciones: null,
        },
        intDialogVisible: false,
        tipo_declaracion: [{
          'id': 1,
          'valor': 'Inicial',
        }, {
          'id': 2,
          'valor': 'Anual',
        }, {
          'id': 3,
          'valor': 'Final'
        }],
        // modalTitle: '',
        loading: false,
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          periodo: '2020'
        },
        dependencias: {},
        filtrainici: false,
        inicialeslst: [{
          'id': 1,
          'valor': 'A-B',
          'cve': '1'
        }, {
          'id': 2,
          'valor': 'C-D',
          'cve': '2'
        }, {
          'id': 3,
          'valor': 'E-F',
          'cve': '3'
        }, {
          'id': 4,
          'valor': 'G-H',
          'cve': '4'
        }, {
          'id': 5,
          'valor': 'I-J',
          'cve': '5'
        }, {
          'id': 6,
          'valor': 'K-L',
          'cve': '1'
        }, {
          'id': 7,
          'valor': 'M-N',
          'cve': '2'
        }, {
          'id': 8,
          'valor': 'Ñ-O',
          'cve': '3'
        }, {
          'id': 9,
          'valor': 'P-Q',
          'cve': '4'
        }, {
          'id': 10,
          'valor': 'R-S',
          'cve': '5'
        }, {
          'id': 11,
          'valor': 'T-U',
          'cve': '3'
        }, {
          'id': 12,
          'valor': 'V-W',
          'cve': '4'
        }, {
          'id': 13,
          'valor': 'X-Z',
          'cve': '5'
        }],
        rol: '',
        filter: '',
        iniciales: '',
        nombre: '',
        activo: null,
        alta: '',
        baja: '',
        filter2: '',
        shhistorico: false,
        shlista: true,
        currentPage: 1,
        table_list: [],
        justificados: [],
        perPage: 50,
        periodos: [],
        rows: null,
        tiposDeclaracion: [{
          'id': 1,
          'tipo_declaracion': 'Inicial'
        }, {
          'id': 2,
          'tipo_declaracion': 'Anual'
        }, {
          'id': 3,
          'tipo_declaracion': 'Final'
        }],
        list_cumplimiento: [],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        headers2: [{
            text: 'Año',
            value: 'periodo',
            align: 'center',
            class: '',
            // width: "200px",
          },
          {
            text: 'Tipo',
            value: 'Tipo_Dec',
            align: 'center',
            class: ''
          },
          {
            text: 'Declaración Patrimonial',
            value: 'patrimonial',
            align: 'center',
            class: ''
          },
          {
            text: 'Declaración fiscal',
            value: 'fiscal',
            align: 'center',
            class: ''
          },
          {
            text: 'Acuse',
            value: 'acuse',
            align: 'center',
            class: ''
          },
          {
            text: 'Aclaraciones',
            value: 'aclaraciones',
            align: 'center',
            class: ''
          },
          {
            text: 'Entidad / Dependencia',
            value: 'entidad',
            align: 'center',
            class: '',
            width: "200px",
          },

          {
            text: 'Cargo',
            value: 'cargo',
            align: 'center',
            class: ''
          },

          {
            text: 'Fecha Posesion',
            value: 'posesion',
            align: 'center',
            class: ''
          },

          {
            text: 'Fecha Presentación',
            value: 'presentacion',
            align: 'center',
            class: ''
          }
        ],
        headers3: [{
            text: 'Año',
            value: 'periodo',
            align: 'center',
            class: '',
            width: "200px",
          },
          {
            text: 'Tipo',
            value: 'Tipo_Dec',
            align: 'center',
            class: ''
          },
          {
            text: 'Acuse',
            value: 'acuse',
            align: 'center',
            class: ''
          },
          {
            text: 'Entidad / Dependencia',
            value: 'entidad',
            align: 'center',
            class: ''
          },

          {
            text: 'Cargo',
            value: 'cargo',
            align: 'center',
            class: ''
          },

          {
            text: 'Fecha Posesion',
            value: 'posesion',
            align: 'center',
            class: ''
          },

          {
            text: 'Fecha Presentación',
            value: 'presentacion',
            align: 'center',
            class: ''
          }
        ],
        headers4: [{
            text: 'Año',
            value: 'periodo',
            align: 'center',
            class: ''
          }, {
            text: 'Tipo Declaracion',
            value: 'tipo_declaracion',
            align: 'center',
            class: '',
            width: "200px",
          },
          {
            text: 'Entidad/Dependencia',
            value: 'valor',
            align: 'center',
            class: ''
          }
        ],
        headers: [{
            text: 'Histórico',
            align: 'center',
            sortable: false,
            value: 'acciones',
            class: ''
          },
          {
            text: 'RFC',
            value: 'rfc',
            align: 'center',
          }, {
            text: 'Nombre',
            value: 'nombres',
            align: 'center',
          }, {
            text: 'Dependencia',
            value: 'entidad',
            align: 'center',
          }, {
            text: 'Área',
            value: 'area',
            align: 'center',
          }, {
            text: 'Cargo',
            value: 'cargo',
            align: 'center',
          },
        ],

        propsToSearch: ['rfc', 'nombres'],
        tableColumns: [{
            prop: 'id',
            label: 'Dec',
            minWidth: 150,
            vif: false
          },
          {
            prop: 'rfc',
            label: 'RFC',
            minWidth: 150,
            vif: true
          },
          {
            prop: 'nombres',
            label: 'Nombre',
            minWidth: 100,
            vif: true
          }
        ]
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      dateFormat2: function (date) {
        return moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY');
      },
      checkPermissions() {
        let permiso = [1, 25];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      getEntidad(item) {
        return JSON.parse(item.datos_encargo_actual)[0].ente.valor
      },
      getFechaPos(item) {
        return this.dateFormat2(JSON.parse(item.datos_encargo_actual)[0].fecha_posesion)
      },
      getCargo(item) {
        return JSON.parse(item.datos_encargo_actual)[0].empleo_cargo_comision
      },
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      // getPeriodos() {
      //   var v = this;
      //   this.$http.get("getPeriodos").then(
      //     response => {
      //       var anios = response.data.periodos;

      //       anios.forEach(y => {
      //         if (y.year) {
      //           this.periodos.push(y);
      //         }
      //       });
      //       this.formItem.periodo = this.periodos[0].year;
      //     },
      //     error => {
      //       this.StepError(error);
      //     }
      //   );
      // },
      descargaFiscal(file) {
        let obj = JSON.parse(file);
        if (obj[0]) {
          var url = ['https:' + this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file];
          window.open(url, '_blank');
        } else {
          this.StepW("No tiene declaración fiscal");
        }

      },
      descargaAclaracion(file) {
        let obj = JSON.parse(file);
        if (obj[0]) {
          var url = ['https:' + this.$rootUrl + '/declaraciones_aclaraciones/' + obj[0].file];
          window.open(url, '_blank');
        } else {
          this.StepW("No tiene aclaraciones");
        }
      },
      traeiniciales() {
        this.loading = true;
        this.coloremp = 'info'
        this.txtemp = 'Buscando...'
        this.filtro_usuarios = [];
        this.list_declarantes2 = [];
        let desde
        let hasta
        if (this.iniciales == 1) {
          desde = 'A';
          hasta = 'C'
        }
        if (this.iniciales == 2) {
          desde = 'C';
          hasta = 'E'
        }
        if (this.iniciales == 3) {
          desde = 'E';
          hasta = 'G'
        }
        if (this.iniciales == 4) {
          desde = 'G';
          hasta = 'I'
        }
        if (this.iniciales == 5) {
          desde = 'I';
          hasta = 'K'
        }
        if (this.iniciales == 6) {
          desde = 'K';
          hasta = 'M'
        }
        if (this.iniciales == 7) {
          desde = 'M';
          hasta = 'O'
        }
        if (this.iniciales == 8) {
          desde = 'O';
          hasta = 'P'
        }
        if (this.iniciales == 9) {
          desde = 'P';
          hasta = 'R'
        }
        if (this.iniciales == 10) {
          desde = 'R';
          hasta = 'T'
        }
        if (this.iniciales == 11) {
          desde = 'T';
          hasta = 'V'
        }
        if (this.iniciales == 12) {
          desde = 'V';
          hasta = 'X'
        }
        if (this.iniciales == 13) {
          desde = 'X';
          hasta = 'ZZ'
        }


        this.$http.get("hdeclaraciones/" + this.model.dependencia_id + '/' + desde + '/' + hasta).then(
          response => {
            this.loading = false;
            this.list_cumplimiento = [];
            response.data.declarantes.forEach((value, key) => {
              this.list_cumplimiento.push({
                'id': value.id,
                'rfc': value.rfc,
                'nombres': value.nombre,
                'entidad': value.entidad,
                'area': value.area,
                'cargo': value.cargo,
                'activo': value.activo,
                'alta': value.alta,
                'baja': value.baja,
                // 'id': value.id,
                // 'rfc': value.rfc,
                // 'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                // 'entidad': value.encargo.ente.valor,
                // 'area': value.encargo.area_adscripcion,
                // 'cargo': value.encargo.empleo_cargo_comision,
                // 'activo': value.tipo_mov,
                // 'alta': value.created_at,
                // 'baja': value.encargo.fecha_termino,
              });
            });
            this.filtro_usuarios = this.list_cumplimiento;
          },
          error => {
            this.loading = false;
            this.StepError(error);
          }
        );
      },
      getDeclaraciones() {
        this.loading = true;
        this.filtrainici = false;
        let dec = 0;
        this.filtro_usuarios = [];
        dec = this.getServid(this.model.dependencia_id)
        if (dec <= 10000) {
          this.$http.post("hdeclaraciones", this.model).then(
            response => {
              this.loading = false;
              this.list_cumplimiento = [];
              // console.log(response.data.declarantes);
              response.data.declarantes.forEach((value, key) => {

                this.list_cumplimiento.push({
                  'id': value.id,
                  'rfc': value.rfc,
                  'nombres': value.nombre,
                  'entidad': value.entidad,
                  'area': value.area,
                  'cargo': value.cargo,
                  'activo': value.activo,
                  'alta': value.alta,
                  'baja': value.baja,
                });

                // this.list_cumplimiento.push({
                //   'id': value.id,
                //   'rfc': value.rfc,
                //   'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                //   'entidad': value.encargo.ente.valor,
                //   'area': value.encargo.area_adscripcion,
                //   'cargo': value.encargo.empleo_cargo_comision,
                //   'activo': value.tipo_mov,
                //   'alta': value.created_at,
                //   'baja': value.encargo.fecha_termino,
                // });

              });
              this.filtro_usuarios = this.list_cumplimiento;
              //console.log(this.filtro_usuarios);
            },
            error => {
              this.loading = false;
              this.StepError(error);
            }
          );
        } else {
          this.Ask2("La dependencia tiene más de 10 mil declarantes, ¿desea realizar filtrado por RFC?", () => {
              this.filtrainici = true;

            },
            () => {
              this.StepInfo("El proceso puede tardar varios minutos.")
              this.$http.post("hdeclaraciones", this.model).then(
                response => {
                  this.loading = false;
                  this.list_cumplimiento = [];
                  response.data.declarantes.forEach((value, key) => {
                    this.list_cumplimiento.push({
                      'id': value.id,
                      'rfc': value.rfc,
                      'nombres': value.nombre,
                      'entidad': value.entidad,
                      'area': value.area,
                      'cargo': value.cargo,
                      'activo': value.activo,
                      'alta': value.alta,
                      'baja': value.baja,
                    });
                    // this.list_cumplimiento.push({
                    //   'id': value.id,
                    //   'rfc': value.rfc,
                    //   'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                    //   'entidad': value.encargo.ente.valor,
                    //   'area': value.encargo.area_adscripcion,
                    //   'cargo': value.encargo.empleo_cargo_comision,
                    //   'activo': value.tipo_mov,
                    //   'alta': value.created_at,
                    //   'baja': value.encargo.fecha_termino,
                    // });
                  });
                  this.filtro_usuarios = this.list_cumplimiento;
                },
                error => {
                  this.loading = false;
                  this.StepError(error);
                }
              );
            });
        }
      },
      /* descargar(row) {
        var url = [this.$http.options.root + 'getDeclaracion1/pdf/' + row.declaracion_id + '/' + this.getKey('uid')];
        window.open(url, '_blank');
      }, */
      descargar(row) {
        /* var url = [this.$http.options.root + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid')];
        window.open(url, '_blank'); */

        this.Ask("¿Desea descargar ésta declaración?", () => {
          let cargando = this.$swal({
            showConfirmButton: false,
            type: "warning",
            title: this.texto,
            text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
            showCloseButton: this.close
          });

          this.$http.get(this.$http.options.root + 'getDeclaracionComp/pdf/' + row.declaracion_id + "/" + this.getKey('uid'), {
            responseType: 'arraybuffer'
          }).then(
            response => {
              this.downloadFile(response, 'Declaración')
            },
            error => {
              this.StepError(error);
            }
          );
        });
      },
      descargaAcuse(row) {
        //console.log(row.declaracion_id);
        this.$http.get(this.$http.options.root + 'getAcuseAdmin/' + row.declaracion_id, {
          responseType: 'arraybuffer'
        }).then(
          //this.$http.get('getDeclaracion/pdf/' +this.ip_id+"/1").then(
          response => {
            this.downloadFile(response, 'Acuse')
          },
          error => {
            this.StepError(error);
          }
        )
      },
      downloadFile(response, filename) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response.body], {
          type: 'application/pdf'
        })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename + '.pdf'
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100)
      },
      historico(row) {
        this.shlista = false;
        this.shhistorico = true;
        this.nombre = row.rfc;
        this.activo = row.activo;
        this.alta = this.dateFormat(row.alta);
        this.baja = null;
        if (row.baja) {
          this.baja = this.dateFormat(row.baja);
        }
        this.$http.get("historicolst/" + row.id).then(
          response => {
            this.table_list = response.data.response;
            this.justificados = response.data.justificados;
            console.log(this.justificados);
          },
          error => {
            this.Err(error);
          }
        );
      },
      historico2(id) {
        this.$http.get("historicolst/" + id).then(
          response => {
            this.table_list = response.data.response;
            this.justificados = response.data.justificados;
            console.log(this.justificados);
          },
          error => {
            this.Err(error);
          }
        );
      },
      editBitacora(item) {
        this.$validator.pause();
        this.correccion = {
          id: null,
          ip_id: null,
          declaracion_id: null,
          dependencia_orgen: null,
          dependencia_orgen_id: null,
          dependencia_destino_id: null,
          periodo: null,
          tipo_declaracion_id: null,
          observaciones: null,
        };

        var ente = JSON.parse(item.datos_encargo_actual)[0].ente;

        this.correccion.ip_id = item.ip_id;
        this.correccion.declaracion_id = item.declaracion_id;
        this.correccion.dependencia_orgen_id = ente.id;
        this.correccion.dependencia_orgen = ente.valor;

        var bitacoraItem = {
          ip_id: item.ip_id,
          declaracion_id: item.declaracion_id
        };

        this.intDialogVisible = true;
        this.modalTitle = "Editar declaración";

        this.loadBitacora = true;
        this.$http.post("bitacoracorreccion_consulta", bitacoraItem).then(
          response => {
            this.loadBitacora = false;
            this.correccion.id = response.data.bitacora.id;
            this.correccion.tipo_declaracion_id = response.data.bitacora.tipo_declaracion_id;
            this.correccion.periodo = response.data.bitacora.periodo;
            // this.correccion.origen = JSON.parse(response.data.bitacora.informacion_personal)[0];
            // console.log(this.correccion.origen);
            // id
            this.$validator.resume();
          },
          error => {
            this.Err(error);
          }
        );
      },
      makeCorrection() {

        this.valida().then(response => {
          if (response) {
            this.loadCorreccion = true;

            this.$http.post("bitacoracorreccion", this.correccion).then(
              response => {
                this.StepOk("Guardado");
                this.loadCorreccion = false;
                this.intDialogVisible = false;
                this.historico2(this.correccion.ip_id);
              },
              error => {
                this.loadCorreccion = false;
                this.StepW(error);
                // this.Err(error);
              }
            );
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      valida() {
        return this.$validator.validateAll();
      },
      regresar() {
        this.shlista = true;
        this.shhistorico = false;
      },
      getServid(index) {
        let a = 0
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              a = item.declarantes_count;
            }
          });
        }
        return a
      }
    },
    created() {
      this.getDependencias();

      this.model.dependencia_id = this.getKey("ente_publico_id");

      this.$http.get("cat/dec").then(
        response => {
          this.dependencias = response.data.entes_publicos;
          this.getDeclaraciones()
        },
        error => {
          this.Err(error);
        }
      );

      this.getPeriodos();
      this.rol = this.getKey('role');

      if (this.rol == 1) {
        this.headers2.unshift({
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: '',
          width: "80px",
        });
      }

      this.checkPermissions()
    }
  }

</script>
<style>
  .theme--light.v-divider {
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  .v-application .text-overline {
    line-height: 1.25rem !important;
    font-weight: bolder !important;
  }

  .card-sub {
    color: rgba(0, 0, 0, .6) !important;
    line-height: 1.2 !important;
    font-size: .875rem !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/HistoricoDeclaraciones.vue